import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import SolicitudTarifas from "./pages/solicitudTarifas/solicitudTarifas";
import TarifasPendientes from "./pages/tarifasPendientes/tarifasPendientes";
import SectionHeader from "../../../components/sectionHeader/sectionHeader";
import Tabs from "../../../components/tabs/tabs";
import ComparativaTarifas from "./pages/comparativaTarifas/comparativaTarifas";
import HistoricoTarifas from "./pages/historicoTarifas.jsx/historicoTarifas";
import Resumen from "./pages/resumen/resumen";
import Precio from "./pages/precio/precio";
import ValidacionGOI from "./pages/validacionGOI/validacionGOI";

export default function GestionTarifas({ user }) {
    const location = useLocation();
    const [activeTab, setActiveTab] = useState("solicitudTarifas");

    useEffect(() => {
        const urlParams = new URLSearchParams(location.search);
        const tabFromUrl = urlParams.get('activeTab');
        if (tabFromUrl) {
            setActiveTab(tabFromUrl);
        }
    }, [location.search]);

    const handleTabChange = (tabId) => {
        setActiveTab(tabId);
    };

    return (
        <section className="dashboard-usuarios">
            <SectionHeader
                title="Panel de Administrador - Gestión de tarifas"
                subtitle="Aquí puedes solicitar precios a proveedores, gestionar las tarifas y ver comparativas de histórico de cambios de precios"
            />

            <Tabs
                tabs={[
                    { id: "solicitudTarifas", label: "Solicitar tarifas" },
                    { id: "tarifasPendientes", label: "Mis pendientes" },
                    { id: "comparativaTarifas", label: "Comparativa tarifas" },
                    { id: "historicoTarifas", label: "Histórico tarifas" },
                    { id: "validacionGOI", label: "Validación GOI" },
                    { id: "resumen", label: "Resumen" },
                    {id: "precio", label: "Calculadora de precios" }
                ]}
                activeTab={activeTab}
                onTabChange={handleTabChange}
            />

            <div className="dashboard-usuarios__content">
                {activeTab === "solicitudTarifas" && <SolicitudTarifas />}

                {activeTab === "tarifasPendientes" && (
                    <TarifasPendientes user={user} />
                )}

                {activeTab === "historicoTarifas" && (
                    <HistoricoTarifas user={user} />
                )}

                {activeTab === "validacionGOI" && (
                    <ValidacionGOI user={user} />
                )}

                {activeTab === "comparativaTarifas" && (
                    <ComparativaTarifas user={user} />
                )}

                {activeTab === "resumen" && <Resumen user={user} />}
                {activeTab === "precio" && <Precio user={user} />}
            </div>
        </section>
    );
}
